var _defs, _path, _path2, _rect, _rect2, _polygon, _polyline, _polyline2, _polyline3, _rect3, _rect4, _polyline4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ba9bc9;}.cls-2{fill:#f4ecce;}.cls-3{fill:#838bc5;}.cls-4{fill:#8f6c56;}.cls-5{fill:#65c8d0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47,36a15,15,0,0,1-30,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42,36a10,10,0,0,1-20,0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 4,
    width: 6,
    x: 23,
    y: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 14,
    width: 17,
    x: 5,
    y: 21
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "30 19 30 20 29 5 23 5 21 35 30 35 31 35 58 35 58 19 30 19"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "41 15 42 5 46 5 47 15"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "50 15 51 5 55 5 56 15"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "32 15 33 5 37 5 38 15"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 6,
    rx: 3,
    width: 30,
    x: 29,
    y: 15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    height: 2,
    width: 60,
    x: 2,
    y: 34
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "7 21 8 11 12 11 13 21"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 6,
    width: 4,
    x: 34,
    y: 25
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 6,
    width: 4,
    x: 50,
    y: 25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 6,
    width: 4,
    x: 42,
    y: 25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 2,
    width: 2,
    x: 8,
    y: 24
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 2,
    width: 2,
    x: 12,
    y: 24
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 2,
    width: 2,
    x: 16,
    y: 24
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 2,
    width: 2,
    x: 8,
    y: 28
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 2,
    width: 2,
    x: 12,
    y: 28
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    height: 2,
    width: 2,
    x: 16,
    y: 28
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 32,
    cy: 60,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 60,
    cy: 60,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 56,
    cy: 52,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 60,
    cy: 44,
    r: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 4,
    cy: 60,
    r: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 8,
    cy: 52,
    r: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 4,
    cy: 44,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60,57a3,3,0,0,0-2.82,2H47V55a1,1,0,0,0-.88-1L39,53.12V50.37a15.94,15.94,0,0,0,3.78-2.59L43,49.16A1,1,0,0,0,44,50h2.59l2.7,2.71A1,1,0,0,0,50,53h3.18a3,3,0,1,0,0-2H50.41l-2.7-2.71A1,1,0,0,0,47,48H44.85l-.34-2.06A16.18,16.18,0,0,0,46.82,42h3.46l.77,2.32A1,1,0,0,0,52,45h5.18a3,3,0,1,0,0-2H52.72L52,40.68A1,1,0,0,0,51,40H47.47A15.56,15.56,0,0,0,48,36H46a14,14,0,0,1-28,0H16a15.56,15.56,0,0,0,.53,4H13a1,1,0,0,0-.95.68L11.28,43H6.82a3,3,0,1,0,0,2H12a1,1,0,0,0,.95-.68L13.72,42h3.46a15.93,15.93,0,0,0,2.31,4l-.34,2H17a1,1,0,0,0-.71.29L13.59,51H10.82a3,3,0,1,0,0,2H14a1,1,0,0,0,.71-.29L17.41,50H20a1,1,0,0,0,1-.84l.22-1.38A15.91,15.91,0,0,0,25,50.37v2.75L17.88,54A1,1,0,0,0,17,55v4H6.82a3,3,0,1,0,0,2H18a1,1,0,0,0,1-1V55.88L26.12,55A1,1,0,0,0,27,54V51.19A16,16,0,0,0,31,52v5.23a3,3,0,1,0,2,0V52a16,16,0,0,0,4-.76V54a1,1,0,0,0,.88,1l7.12.89V60a1,1,0,0,0,1,1H57.18A3,3,0,1,0,60,57Zm-4-6a1,1,0,1,1-1,1A1,1,0,0,1,56,51Zm4-8a1,1,0,1,1-1,1A1,1,0,0,1,60,43ZM4,45a1,1,0,1,1,1-1A1,1,0,0,1,4,45Zm4,8a1,1,0,1,1,1-1A1,1,0,0,1,8,53ZM4,61a1,1,0,1,1,1-1A1,1,0,0,1,4,61Zm28,0a1,1,0,1,1,1-1A1,1,0,0,1,32,61Zm28,0a1,1,0,1,1,1-1A1,1,0,0,1,60,61Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/loginIcon.fe4fc7e37b45ba87f03811321cd67722.svg";
export { ForwardRef as ReactComponent };